module.exports = __webpack_public_path__ + "img/bg-register.d368417f.png";